<template>
    <div v-loading="loading">
        <div style="text-align: center">
            <span class="name-label">{{record.companyname}}</span>
        </div>

        <div class="select-area-box">
            <div>
                <span tkey="價格">{{i18n.tkey("lang_price_text")}}</span>
                <br>
              <el-input
                  v-model="record.raddinfo2"
                  type="number"
                  autocomplete="off"
              />
            </div>

            <div>
              <span tkey="點擊數">{{i18n.tkey("lang_click")}}{{i18n.tkey("lang_qty")}}</span>
                <br>
              <el-input
                  v-model="record.raddinfo3"
                  type="number"
                  autocomplete="off"
              />
            </div>
        </div>

        <div style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="clickSave" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>

    </div>
</template>

<script setup>

import {inject, toRef, computed, onBeforeMount, ref, reactive} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import record16Api from "@/request/record16Api";

const props = defineProps(["record", "type"])
const emits = defineEmits(["save-complete"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)







function clickSave(){

    if(myUtil.isEmpty(props.record.cost)){

      myUtil.alertError(i18n.tkey('lang_product_cost_is_not_null'))
      return
    }


    if(myUtil.isEmpty(props.record.raddinfo3)){
      props.record.raddinfo3 = '0'
    }

    loading.value = true

    const request = record16Api.updateRecord16Position
    const params = request.getParams()

    params.id = props.record.rupdatedid
    params.addinfo2 = props.record.raddinfo2
    params.addinfo3 = props.record.raddinfo3

    request.send(params, (res) => {
      loading.value = false
      if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else{
            myUtil.alertError(i18n.tkey("lang_save_failed"))
        }
    })


}

onBeforeMount(() => {


})

</script>

<style scoped>
    .select-area-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 30px;
    }

    .name-label {
        color: #303133;
        font-size: 1.2em;
        font-weight: 600;
    }
</style>